module.exports = __webpack_public_path__ + "static/media/summary1.5e3669c9.svg";